"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manufacturerSection = void 0;
const types_1 = require("../../../types");
exports.manufacturerSection = {
    label: "Hersteller",
    name: "manufacturer",
    subline: "Geben Sie die Rahmendaten des Herstellers an.",
    fields: [
        {
            name: "name",
            label: "Geschäftsführung",
            type: types_1.FormFieldType.full,
        },
        // {
        //   name: "first_name",
        //   label: "Vorname",
        //   type: FormFieldType.input,
        // },
        // {
        //   name: "last_name",
        //   label: "Nachname",
        //   type: FormFieldType.input,
        // },
        {
            name: "email_adress",
            label: "Email-Addresse",
            type: types_1.FormFieldType.long,
        },
        {
            name: "country",
            label: "Land",
            type: types_1.FormFieldType.select,
            options: [
                { label: "Deutschland", value: "germany" },
                { label: "Österreich", value: "austria" },
                { label: "Schweiz", value: "switzerland" },
            ],
        },
        {
            name: "street_address",
            label: "Straße, Hausnummer",
            type: types_1.FormFieldType.full,
        },
        {
            name: "city",
            label: "Stadt",
            type: types_1.FormFieldType.short,
        },
        {
            name: "state",
            label: "Bundesland",
            type: types_1.FormFieldType.short,
        },
        {
            name: "post_code",
            label: "PLZ",
            type: types_1.FormFieldType.short,
        },
    ],
};
exports.default = exports.manufacturerSection;
